import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebase/config';
import InitializePins from './components/admin/InitializePins';

// Auth Components
import LandingPage from './components/LandingPage';
import RoleLogin from './components/auth/RoleLogin';
import StaffLogin from './components/auth/StaffLogin';

// NEW: Unified Dashboard and Admin Dashboard
import UnifiedDashboard from './components/dashboard/UnifiedDashboard';
import AdminDashboard from './components/dashboard/AdminDashboard';

// Old Dashboards (keep for backward compatibility)
import StudentDashboard from './components/dashboards/StudentDashboard';
import MentorDashboard from './components/dashboards/MentorDashboard';
import CoordinatorDashboard from './components/dashboards/CoordinatorDashboard';
import MentoringCoordDashboard from './components/dashboards/MentoringCoordDashboard';
import HODDashboard from './components/dashboards/HODDashboard';

// Features
import AchievementForm from './components/features/AchievementForm';
import PsychometricTest from './components/features/PsychometricTest';
import LeaveForm from './components/features/LeaveForm';
import StudentProfile from './components/features/StudentProfile';
import StudentMahiti from './components/features/StudentMahiti';
import Fillyourinfo from './components/features/Fillyourinfo';
import AttendanceUndertaking from './components/features/AttendanceUndertaking';

// Reports
import AttendanceReport from './components/reports/AttendanceReport';
import IATest1Report from './components/reports/IATest1Report';
import IATest2Report from './components/reports/IATest2Report';
import AttendanceRep from './components/reports/AttendanceRep';
import IAT1Rep from './components/reports/IAT1Rep';
import IAT2Rep from './components/reports/IAT2Rep';
import EndSemesterReport from './components/reports/EndSemesterReport';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading YBIT Mentoring System...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/hod-login" element={<RoleLogin loginType="hod" />} />
        <Route path="/faculty-login" element={<RoleLogin loginType="faculty" />} />
        <Route path="/student-login" element={<RoleLogin loginType="student" />} />
        <Route path="/staff-login" element={<StaffLogin />} />
        <Route path="/developer-login" element={<StaffLogin />} />
<Route path="/admin/initialize-pins" element={<InitializePins />} />
        
        {/* NEW: Unified Dashboard and Admin Dashboard */}
        <Route path="/dashboard" element={<UnifiedDashboard />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        
        {/* Redirect old settings route to admin dashboard */}
        <Route path="/settings" element={<Navigate to="/admin-dashboard" replace />} />
        
        {/* Student Routes */}
        <Route path="/student/dashboard" element={<StudentDashboard />} />
        <Route path="/student/dashboard/view/:viewId" element={<StudentDashboard />} />
        <Route path="/student/profile" element={<StudentProfile />} />
        <Route path="/student/profile/view/:viewId" element={<StudentProfile />} />
        <Route path="/student/profile/:rollNumber" element={<StudentProfile />} />
        <Route path="/student/mahiti" element={<StudentMahiti />} />
        <Route path="/student/mahiti/view/:viewId" element={<StudentMahiti />} />
        <Route path="/student/mahiti/:rollNumber" element={<StudentMahiti />} />
        <Route path="/student/achievements" element={<AchievementForm />} />
        <Route path="/student/psychometric-test" element={<PsychometricTest />} />
        <Route path="/student/apply-leave" element={<LeaveForm />} />
        <Route path="/student/fill-your-info" element={<Fillyourinfo />} />
        <Route path="/student/attendance-undertaking" element={<AttendanceUndertaking />} />
        <Route path="/student/attendance-undertaking/view/:viewId" element={<AttendanceUndertaking />} />
        <Route path="/student/attendance-undertaking/:rollNumber" element={<AttendanceUndertaking />} />
        
        {/* Student Report Routes */}
        <Route path="/student/attendance-report" element={<AttendanceReport />} />
        <Route path="/student/attendance-report/view/:viewId" element={<AttendanceReport />} />
        <Route path="/student/attendance-report/:rollNumber" element={<AttendanceReport />} />
        <Route path="/student/ia-test1-report" element={<IATest1Report />} />
        <Route path="/student/ia-test1-report/view/:viewId" element={<IATest1Report />} />
        <Route path="/student/ia-test1-report/:rollNumber" element={<IATest1Report />} />
        <Route path="/student/ia-test2-report" element={<IATest2Report />} />
        <Route path="/student/ia-test2-report/view/:viewId" element={<IATest2Report />} />
        <Route path="/student/ia-test2-report/:rollNumber" element={<IATest2Report />} />
        <Route path="/student/end-semester-report" element={<EndSemesterReport />} />
        <Route path="/student/end-semester-report/view/:viewId" element={<EndSemesterReport />} />
        <Route path="/student/end-semester-report/:rollNumber" element={<EndSemesterReport />} />
        
        {/* New Report Routes (Popup versions) */}
        <Route path="/attendance-report/view/:viewId" element={<AttendanceRep />} />
        <Route path="/attendance-report/:rollNumber" element={<AttendanceRep />} />
        <Route path="/iat1-report/view/:viewId" element={<IAT1Rep />} />
        <Route path="/iat1-report/:rollNumber" element={<IAT1Rep />} />
        <Route path="/iat2-report/view/:viewId" element={<IAT2Rep />} />
        <Route path="/iat2-report/:rollNumber" element={<IAT2Rep />} />
        
        {/* Old Staff Routes (keep for backward compatibility) */}
        <Route path="/mentor/dashboard" element={<MentorDashboard />} />
        <Route path="/coordinator/dashboard" element={<CoordinatorDashboard />} />
        <Route path="/mentoring-coordinator/dashboard" element={<MentoringCoordDashboard />} />
        <Route path="/hod/dashboard" element={<HODDashboard />} />
        
        {/* Fallback Route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
